import {EntityBase} from "../../shared/entity/EntityBase";

const COUNTRY_DATA_FIELDS = {
    countryCode: { defaultValue: '' },
    langCode: { defaultValue: '' },
    countryName: { defaultValue: '' },
    languageName: { defaultValue: '' },
}
export class CountryDataEntity extends EntityBase {
    constructor(data = {}) {
        super(data, COUNTRY_DATA_FIELDS);

        this.isNew = !data.countryCode;

        this.errors = [
            { condition: () => this.countryCode.length <= 0, message: '국가 코드가 없습니다.' },
            { condition: () => this.langCode.length <= 0, message: '언어 코드가 없습니다.' },
            { condition: () => this.countryName.length <= 0, message: '국가 이름이 없습니다.' },
            { condition: () => this.languageName.length <= 0, message: '언어 이름이 없습니다.' }
        ]
    }

    toJson() {
        const { errors, isNew, ...rest } = this;
        return JSON.parse(JSON.stringify(rest));
    }
}